"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceReact = void 0;
var react_1 = __importDefault(require("react"));
var replaceReact = function (str, match, replacementFn) {
    var parts = str.split(match);
    for (var i = 1; i < parts.length; i += 2) {
        parts[i] = replacementFn(parts[i], i);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, parts);
};
exports.replaceReact = replaceReact;
